import React, { useState } from 'react';
import { Table, Pagination, Row, Col, ConfigProvider, Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import GenericExportCSV from '../csv/ExportCSV';
import { GenericTableProps, BaseTableData } from '../../types/TableTypes';
import './Table.css';
import jaJP from "antd/es/locale/ja_JP";

const GenericTable = <T extends BaseTableData>({
  data,
  allData,
  columns,
  exportColumns = [],
  total = 0,
  pageSize = 10,
  currentPage = 1,
  loading = false,
  onPageChange,
  onChange,
  onRow,
  tableTitle = "Danh sách dữ liệu",
  exportFilename = "データ",
  onPropertyTypeChange,
  propertyType = 'all',
  fetchAllData,
}: GenericTableProps<T>) => {
  const handlePageChange = (page: number, size: number) => {
    // ページ数変更時のみスクロール位置を上に戻す
    if (page !== currentPage) {
      const tableContainer = document.querySelector('.custom-table-container');
      if (tableContainer) {
        tableContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      // テーブル本体のスクロールも一番上に戻す
      const tableBody = document.querySelector('.custom-table .ant-table-body');
      if (tableBody) {
        (tableBody as HTMLElement).scrollTop = 0;
      }
    }
    // 件数変更時はスクロール位置を維持
    if (onPageChange) {
      onPageChange(page, size);
    }
  };

  const handlePropertyTypeChange = (e: RadioChangeEvent) => {
    if (onPropertyTypeChange) {
      onPropertyTypeChange(e.target.value);
    }
  };

  return (
    <div className={`custom-table-container ${loading ? "table-loading" : ""}`}>
      {onPropertyTypeChange && (
        <Row style={{ marginBottom: 16 }}>
          <Col>
            <div style={{ color: "#374151" }}>
              <span style={{ marginRight: 16, fontWeight: 500 }}>物件種別：</span>
              <Radio.Group 
                onChange={handlePropertyTypeChange} 
                value={propertyType}
              >
                <Radio value="all">全て</Radio>
                <Radio value="sale">売出のみ</Radio>
                <Radio value="contracted">成約のみ</Radio>
              </Radio.Group>
            </div>
          </Col>
        </Row>
      )}
      
      <Row justify='space-between' align='middle' style={{ marginBottom: 16 }}>
        <Col>
          <h3 style={{ margin: 0, color: "#374151" }}>
            {total} 件
          </h3>
        </Col>
        <Col>
          {allData && allData.length > 0 && (
            <GenericExportCSV
              allData={allData}
              exportColumns={exportColumns}
              filename={exportFilename}
              loading={loading}
              fetchAllData={fetchAllData}
            />
          )}
        </Col>
      </Row>

      <Table<T>
        className='custom-table'
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
        onChange={onChange}
        onRow={onRow}
        scroll={{ y: 800 }}
      />

      <div className='custom-pagination'>
        <ConfigProvider locale={jaJP}>
          <Pagination
            current={currentPage}
            total={total}
            pageSize={pageSize}
            showTotal={(total, range) =>
              `全${total}件中${range[0]}～${range[1]}件`
            }
            showSizeChanger
            onChange={handlePageChange}
            onShowSizeChange={handlePageChange}
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default GenericTable;